import VueRouter from "vue-router";
import menuView from "@/router/menuView.js";
import { parameter, pathAuth } from '@/axios/api.js';

function toRouter(array, item, children) {
    array.push({
        path: item.Path, component: menuView[item.Path], meta: { title: item.Title, engTitle: item.EngTitle, directory: item.Directory, requireAuth: item.RequireAuth }, children: children
    });
}

const install = function (Vue) {
    Vue.use(VueRouter);
}

const menuRoutes = function () {
    return parameter.router().then(function (res) {
        if (res.status == 200) {
            const $menu = res.data;
            window.$menu = $menu;

            const menuroutes = [];
            $menu.forEach(function (item) {
                if (item.Directory) {
                    let children = [];
                    item.children.forEach(function (citem) { toRouter(children, citem); });
                    toRouter(menuroutes, item, children);
                } else {
                    toRouter(menuroutes, item);
                }
            });

            const router = new VueRouter({
                mode: "history",
                routes: [
                    {
                        path: "", component: menuView['routerPage'], meta: { title: "首頁", engTitle: "Home" }, children: [
                            { path: "/", component: menuView["/"] },
                            ...menuroutes
                        ]
                    },
                    //{ path: "*", redirect: "/" }
                ]
            });

            router.beforeEach((to, from, next) => {
                if (to.path === "/") {
                    return next();
                }

                if (to.meta.directory) {
                    return next({ path: "/" });
                }

                pathAuth(to.path)
                    .then(function (res) {
                        if (res.data) {
                            next();
                        } else {
                            router.app.$bvToast.toast("沒有權限", { variant: 'danger', solid: true });
                        }
                    })
                    .catch(function (error) {
                        if (error.response.status == 401) {
                            router.app.$bvToast.toast(`${error.response.status}-請先登入`, { variant: 'danger', solid: true });
                            return next({ path: "/" });
                        } else {
                            router.app.$bvToast.toast(`發生錯誤(${error.toString()})`, { variant: 'danger', solid: true });
                        }
                    });
            });
            return Promise.resolve(router);
        } else {
            return Promise.reject();
        }
    });
};

export default { install }
export { menuRoutes }